<template>
  <div>
    <section class="mainPart">
        <!--S 检索-->
        <el-form :model="searchGLForm" inline class="searchForm">
            <el-form-item label="出库时间">
                <!-- S 双日期选择器 -->
                <TwoDatePicker
                    @twoDateObtain="outDateReceive"
                    :startvaldate="searchGLForm.outTime.length>0?searchGLForm.outTime[0]:''"
                    :endvaldate="searchGLForm.outTime.length>0?searchGLForm.outTime[1]:''"
                    key="out">
                </TwoDatePicker>
                <!-- E 双日期选择器 -->
            </el-form-item>
            <el-form-item label="提货时间">
                <!-- S 双日期选择器 -->
                <TwoDatePicker
                    @twoDateObtain="paiDateReceive"
                    :startvaldate="searchGLForm.paiTime.length>0?searchGLForm.paiTime[0]:''"
                    :endvaldate="searchGLForm.paiTime.length>0?searchGLForm.paiTime[1]:''"
                    key="pai">
                </TwoDatePicker>
                <!-- E 双日期选择器 -->
            </el-form-item>
            <el-form-item label="券卡状态">
                <CardState :isState="searchGLForm.cardState" @cardStateObtain="cardStateObtain" :type="1"></CardState>
            </el-form-item>
            <el-form-item label="券卡介质" class="formTimeSlot">
                <CardMedium :isMedium="searchGLForm.cardMedium" @cardMediumObtain="cardMediumObtain"></CardMedium>
            </el-form-item>
            <el-form-item label="送货方式" class="formTimeSlot">
                <el-select v-model="searchGLForm.delimode" clearable placeholder="请选择">
                    <el-option label="自提" :value="0"></el-option>
                    <el-option label="送货" :value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="券卡流向">
                <el-select v-model="searchGLForm.flowcode" class="filterMultiIpt" popper-class="scrollSelect" multiple collapse-tags filterable clearable placeholder="请选择或输入" :filter-method="filterFlow" @focus="getFlowList(0)" @visible-change="closeFlowName">
                    <div class="optionBox" :class="{'showPage':flowList.length<=30}">
                    <el-option
                        v-for="item in flowList"
                        :key="item.flowcode"
                        :label="item.flowname"
                        :value="item.flowcode">
                    </el-option>
                    </div>
                    <el-pagination
                        @current-change="flowCurrentChange" :hide-on-single-page="true" 
                        :current-page="flowCurrent"
                        :page-sizes="[30]"
                        :page-size="30"
                        layout="pager"
                        :total="flowBean.totalnum" v-show="flowBean.totalnum>30"
                        small>
                    </el-pagination>
                </el-select>
            </el-form-item>
            <el-form-item label="由流向方发货">
              <el-select v-model="searchGLForm.bbindflowsend" filterable placeholder="请选择或输入" clearable>
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="querySubmit">查询</el-button>
                <el-button type="primary" plain @click="exportAccountsCardDetail" v-if="cardStatisticsList.length>0">导出</el-button>
                <el-button type="primary" plain @click="$router.back(-1)">返回</el-button>
            </el-form-item>
        </el-form>
        <!--E 检索-->
        <!-- 注意：有合并表头样式的table，这里要加类名borderIndiv -->
        <div class="gsListTable individualiz borderIndiv">
            <!--S 列表-->
            <!-- 注意：有合并表头样式的table要加类名borderTable -->
            <el-table ref="gsTable" class="gsTable comTable borderTable" border :data="cardStatisticsList" :maxHeight="tableHeight" v-loading="loading">
                <el-table-column type="index" label="序号" fixed></el-table-column>
                <el-table-column label="券卡编码" min-width="290" fixed>
                    <template slot-scope="scope">
                      <p :title="scope.row.code+'【'+scope.row.serial+'】'">{{scope.row.code}}<b v-show="scope.row.serial">【{{scope.row.serial}}】</b></p>
                    </template>
                </el-table-column>
                <el-table-column label="手机号码" min-width="160">
                    <template slot-scope="scope">
                      <p :title="scope.row.phone">{{scope.row.phone | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="券卡状态" min-width="120">
                    <template slot-scope="scope">
                        <span :class="{
                            'orangeColor':scope.row.stateName == '未激活' || scope.row.stateName == '未提货'||scope.row.stateName == '部分提货',
                            'greenColor': scope.row.stateName == '已提货',
                            'greyColor': scope.row.stateName!='未激活'&&scope.row.stateName!='未提货'&&scope.row.stateName!='部分提货'&&scope.row.stateName!='已提货'
                        }">
                            {{scope.row.stateName}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="券卡用途" min-width="120">
                    <template slot-scope="scope">
                        <span>{{scope.row.carduseName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="券卡介质" min-width="120">
                    <template slot-scope="scope">
                        <span :class="{'orangeColor':scope.row.cardmediumName == '电子券卡', 'blueColor': scope.row.cardmediumName == '实体券卡'}">{{scope.row.cardmediumName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="券卡类型" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.cardkind">{{scope.row.cardkind?scope.row.cardkind:'未设置'}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="使用次数" min-width="120">
                    <template slot-scope="scope">
                        {{scope.row.usenum}}
                    </template>
                </el-table-column>
                <el-table-column label="剩余次数" min-width="120">
                    <template slot-scope="scope">
                        {{scope.row.residuenum}}
                    </template>
                </el-table-column>
                <el-table-column label="可选商品数量" min-width="150">
                    <template slot-scope="scope">
                        {{scope.row.selnum}}
                    </template>
                </el-table-column>
                <el-table-column label="默认商品" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.defaultgoodsname">{{scope.row.defaultgoodsname | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="可选专区/商品" min-width="150">
                    <template slot-scope="scope">
                        <a href="javascript:;" @click="seeGoodsInfo(scope.row.code)" tag="p" class="hand iconhand" v-if="scope.row.defaultgoodscode || scope.row.optgoodsuid">共{{scope.row.selzones?scope.row.selzones:1}}个可选专区</a>
                        <span v-else>无可选专区</span>
                    </template>
                </el-table-column>
                <el-table-column label="最新兑换商品" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.actgoodsname">{{scope.row.actgoodsname | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="券卡面值(￥)" min-width="150">
                    <template slot-scope="scope">{{scope.row.cardprice | empty}}</template>
                </el-table-column>
                <el-table-column label="总部售价(￥)" min-width="150">
                    <template slot-scope="scope">{{scope.row.cardsmallprice | empty}}</template>
                </el-table-column>
                <el-table-column label="门店售价(￥)" min-width="150">
                    <template slot-scope="scope">{{scope.row.lcardsmallprice | empty}}</template>
                </el-table-column>
                <!-- <el-table-column label="二级分销售价(￥)" min-width="180">
                    <template slot-scope="scope">{{scope.row.tcardsmallprice | empty}}</template>
                </el-table-column> -->
                <el-table-column label="付款状态" min-width="180">
                    <template slot-scope="scope">
                        <p :class="{
                            'redColor':scope.row.paystatusName == '待付款',
                            'greenColor': scope.row.paystatusName == '部分付款',
                            'greyColor': scope.row.paystatusName=='部分退款'||scope.row.paystatusName=='全部退款'||scope.row.paystatusName=='无需退款',
                            'blueColor': scope.row.paystatusName=='已付款'
                        }">{{scope.row.paystatusName}}</p>
                        <small v-show="scope.row.paydate">{{scope.row.paydate}}</small>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="付款时间" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.paydate}}</p>
                    </template>
                </el-table-column> -->
                <el-table-column label="定义类型" min-width="150">
                    <template slot-scope="scope">
                        <span :title="scope.row.deftypeName">{{scope.row.deftypeName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="总部券卡流向" min-width="150">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.flowname">{{scope.row.flowname}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="门店券卡流向" min-width="150">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.lflowname">{{scope.row.lflowname}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="有效期" min-width="180" align="center" header-align="center">
                    <template slot-scope="scope">
                      <div class="center" v-if="scope.row.allvaldate.indexOf('-')!=-1">
                        <p v-show="scope.row.allvaldate.split('~')[0]">{{scope.row.allvaldate.split('~')[0]}}</p>
                        <p>~</p>
                        <p v-show="scope.row.allvaldate.split('~')[1]">{{scope.row.allvaldate.split('~')[1]}}</p>
                      </div>
                      <p v-else class="center">{{scope.row.allvaldate}}</p>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="结束有效期" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.endvaldate}}</p>
                    </template>
                </el-table-column> -->
                <el-table-column label="由流向方发货" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.bbindflowsendName}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="只可到店提货" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.isbindstoreName}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="面单打印备注" min-width="250">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.printmemo">{{scope.row.printmemo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="客服备注" min-width="250">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.sermemo">{{scope.row.sermemo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="售卡渠道" min-width="150">
                    <template slot-scope="scope">
                        <span :title="scope.row.channelname">{{scope.row.channelname | empty}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="出库时间" min-width="120">
                    <template slot-scope="scope">
                       {{scope.row.foperdate}}
                    </template>
                </el-table-column>
                <el-table-column label="出库备注" min-width="250">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.sermemo">{{scope.row.memo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="激活时间" min-width="120">
                    <template slot-scope="scope">
                      {{scope.row.actdate | empty}}
                    </template>
                </el-table-column>
                <el-table-column label="激活备注" min-width="250">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.sermemo">{{scope.row.actmemo | empty}}</p>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="回收时间" min-width="120">
                    <template slot-scope="scope">
                        {{scope.row.reycledate | empty}}
                    </template>
                </el-table-column>
                <el-table-column label="回收备注" min-width="250">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.sermemo">{{scope.row.reyclememo | empty}}</p>
                    </template>
                </el-table-column> -->
                <el-table-column label="最近一次操作时间" min-width="200">
                    <template slot-scope="scope">
                        <span :title="scope.row.upddate">{{scope.row.upddate}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="最近一次提货订单号" min-width="200">
                    <template slot-scope="scope">
                        <span :title="scope.row.orderno">{{scope.row.orderno | empty}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单状态" min-width="120">
                    <template slot-scope="scope">
                        <span :class="[{'greenColor':scope.row.ordstateName=='已发货' || scope.row.ordstateName=='配货中' || scope.row.ordstateName=='部分发货'},{'orangeColor':scope.row.ordstateName=='待处理' || scope.row.ordstateName=='待付款'},{'greyColor':scope.row.ordstateName=='订单取消' },{'redColor':scope.row.ordstateName=='问题结单'||scope.row.ordstateName=='已退款'},{'blueColor': scope.row.ordstateName=='正常结单'},]">{{scope.row.ordstateName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单来源" min-width="120">
                    <template slot-scope="scope">
                        <span :title="scope.row.prosourceName">{{scope.row.prosourceName | empty}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="提货终端" min-width="120">
                    <template slot-scope="scope">
                        <span :title="scope.row.terminaltypeName">{{scope.row.terminaltypeName | empty}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="送货方式" min-width="120">
                    <template slot-scope="scope">
                        <span :class="scope.row.delimodeName=='送货'?'blueColor':'orangeColor'">{{scope.row.delimodeName?scope.row.delimodeName:'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="所属订单内容" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.ordercontent">{{scope.row.ordercontent | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="所属订单商品总额(￥)" min-width="200">
                    <template slot-scope="scope">
                        {{scope.row.allamount | empty}}
                    </template>
                </el-table-column>
                <el-table-column label="买家备注" min-width="250">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.buyermemo">{{scope.row.buyermemo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="卖家备注" min-width="250">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.sellermemo">{{scope.row.sellermemo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="订单备注" min-width="250">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.ordermemo">{{scope.row.ordermemo | empty}}</p>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="下单时间" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.submitdate}}</p>
                    </template>
                </el-table-column> -->
                <el-table-column label="下单人" min-width="230">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.orderuname">{{scope.row.orderuname | empty}}</p>
                        <small v-show="scope.row.submitdate" :title="scope.row.submitdate">下单时间：{{scope.row.submitdate}}</small>
                    </template>
                </el-table-column>
                <el-table-column label="订单归属" min-width="120">
                    <template slot-scope="scope">
                      <span :title="scope.row.operpowerName">{{scope.row.operpowerName | empty}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单归属方" min-width="120">
                    <template slot-scope="scope">
                      <p class="textHiden" :title="scope.row.handlercodeName">{{scope.row.handlercodeName | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="期望发货日期" min-width="200">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.recvdate">{{scope.row.recvdate | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="收货信息" min-width="400">
                    <template slot-scope="scope">
                        <div v-if="scope.row.receivername || scope.row.receivertel || scope.row.othtel || scope.row.fulladdr">
                          <p class="blackColor">
                            <b v-show="scope.row.receivername" class="iconuser" :title="scope.row.receivername">{{scope.row.receivername}}</b>&nbsp;&nbsp;
                            <b v-show="scope.row.receivertel || scope.row.othtel" class="icongh" :title="scope.row.receivertel?scope.row.receivertel:scope.row.othtel">{{scope.row.receivertel?scope.row.receivertel:scope.row.othtel}}</b>
                          </p>
                          <small class="textFl pdr50" :title="scope.row.fulladdr">{{scope.row.fulladdr?scope.row.fulladdr:'--'}}</small>
                        </div>
                        <p v-else>--</p>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="联系方式" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.receivertel}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="备用联系方式" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.othtel}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="收货地址" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.fulladdr">{{scope.row.fulladdr}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="结单日期" min-width="120">
                    <template slot-scope="scope">
                        <span :title="scope.row.enddate">{{scope.row.enddate}}</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="结单信息" min-width="250">
                    <template slot-scope="scope">
                        <p v-show="scope.row.endmemo" class="textFl" :title="scope.row.endmemo">{{scope.row.endmemo}}</p>
                        <small v-show="scope.row.enddate" :title="scope.row.enddate">{{scope.row.enddate}}</small>
                        <span v-show="scope.row.endmemo == null && scope.row.enddate==null">--</span>
                    </template>
                </el-table-column>
                <template slot="empty">
                    <div class="noData"><span>暂无数据</span></div>
                </template>
            </el-table>
            <!--E 商品列表-->
        </div>
        <!-- S 分页 -->
        <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
        <!-- S 分页 -->
    </section>
    <!-- S 专区商品信息 -->
    <GoodsChoose :goodsChoseDialogVisible="goodsChoseDialogVisible" :isCardCode="cardCode" @closeGoodsPop="closeGoodsChoose"></GoodsChoose>
    <!-- E 专区商品信息 -->
  </div>
</template>
<script>
import { MessageBox } from "element-ui";
import api from '@/apis/api.js';
export default {
    name:'CardStatisticsDetail',
    data () {
        return {
            currentTit:0, //当前选中菜单
            searchGLForm:{
                cardState: [], // 券卡状态
                cardMedium: '', // 券卡介质
                flowcode: [], // 流向方编号
                delimode: '', // 送货方式
                bbindflowsend: '', // 是否由流向方发货
                outTime: [], // 出库时间
                paiTime: [], // 提货时间
            },
            tableHeight: window.innerHeight*.8, //表格动态高度
            flowList: [], // 流向方列表
            queryFlowname: '', // 检索的流向名称
            flowCurrent: 1, // 请求的商品的页面
            flowBean: { // 返回的商品分页信息
                totalnum: 0,
            },
            pageSize: 30, // 每页展示的条数
            currentPage: 1, // 当前请求的页数
            pagebBean: {
                totalnum: 0,
            }, // 获取到的列表分页信息
            cardStatisticsList: [], // 券卡统计详情列表
            multipleSelection: [], // 选中的列表数据
            printingShow: true, // 防止多次点击导出按钮
            goodsChoseDialogVisible: false, // 商品弹窗是否显示
            cardCode: '', // 查看商品的券卡编号
            queryParams: '', // 归类列表查询参数
            loading: false, // 加载中弹窗显示和隐藏
            ticsQueryInfo: '', // 传递过来的检索条件
            cardkind: '', // 券卡类型
        }
    },
    filters: {
        tjcardStateFilter(value) {
            if (value == 0) {
                return '未激活';
            } else if (value == 1) {
                return '未提货';
            } else if (value == 2) {
                return '部分提货';
            } else if (value == 3) {
                return '已提货';
            } else if (value == 4) {
                return '暂停提货';
            } else if (value == 5) {
                return '已回收';
            } else if (value == 6) {
                return '已作废';
            } else if (value == 7) {
                return '回收折现';
            }
        }
    },
    components: {
        Page: resolve => require(["@/components/common/Page.vue"], resolve),
        TwoDatePicker: resolve => require(["@/components/common/TwoDatePicker.vue"], resolve), // 双日期选择器组件
        MemberChose: resolve =>require(["@/components/common/MemberChose.vue"], resolve), //选择会员
        GoodsChoose: resolve =>require(["@/components/StatisticsFolder/GoodsChoose.vue"], resolve), // 专区商品信息组件
        CardState: resolve =>require(["@/components/Gadget/CardState.vue"], resolve), // 券卡状态下拉组件
        CardMedium: resolve =>require(["@/components/Gadget/CardMedium.vue"], resolve), // 券卡介质下拉组件
    },
    // ============================================== 监听 ==============================================
    watch: {
        
    },
    // ============================================== 方法 ==============================================
    methods: {
        // 导出券卡详细列表
        exportAccountsCardDetail() {
            let exportParams = this.returnQueryInfo();
            this.loading = true;
            api.GET_URLFORACCOUNTSCARDDETAIL(exportParams).then(res => {
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data != 'null') {
                        window.location.href = res.data.data;
                        this.$message({
                            type: 'success',
                            message: res.data.message
                        })
                    }
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
                this.loading = false;
            }).catch(res => {
                this.loading = false;
            })
        },
        // 接收选中的提货时间
        paiDateReceive(info) {
            if(info&&info.length>0) {
                this.searchGLForm.paiTime[0] = info[0];
                this.searchGLForm.paiTime[1] = info[1];
            } else {
                this.searchGLForm.paiTime = [];
            }
        },
        // 接收选中的出库时间
        outDateReceive(info) {
            if(info&&info.length>0) {
                this.searchGLForm.outTime[0] = info[0];
                this.searchGLForm.outTime[1] = info[1];
            } else {
                this.searchGLForm.outTime = [];
            }
        },
        // 获取券卡介质的值
        cardMediumObtain(val) {
            this.searchGLForm.cardMedium = val;
        },
        //动态获取表格高度
        getHeight() {
            let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
            //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
            this.tableHeight = window.innerHeight - tbHeight - 130; 
            this.$nextTick(() => {
              this.$refs.gsTable.doLayout()
            })
        },
        // 获取流向方列表
        getFlowList(size) {
            let flowParams = {
                isMdAccount: 1,
                objtypes: [0],
                isShowSelf: 1,
                keyword: this.queryFlowname,
                pageparam: {
                    pagesize: size?size:30, //每页条数
                    currentpage: this.flowCurrent, //当前页数
                    isnewcomp: 1 //是否需要重新统计页数
                }
            }
            api.GET_LISTFLOWINFO(flowParams).then(res => {
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data != 'null') {
                        this.flowList = res.data.data;
                    } else {
                        this.flowList = [];
                    }
                    this.flowBean = res.data.pagebean;
                }
            })
        },
        // 规格分页
        flowCurrentChange(val) {
            this.flowCurrent = val;
            this.getFlowList();
        },
        // 搜索规格方法
        filterFlow(item) {
            this.queryFlowname = item;
            this.flowCurrent = 1;
            this.getFlowList();
        },
        // 清除筛选的名称
        closeFlowName() {
            this.queryFlowname = '';
            this.flowCurrent = 1;
            this.getFlowList();
        },
        // 返回请求参数
        returnQueryInfo() {
            let detailParams = {
                flowcode: this.searchGLForm.flowcode,
                state: this.searchGLForm.cardState!=7?this.searchGLForm.cardState:[8],
                cardmedium: this.searchGLForm.cardMedium,
                delimode: this.searchGLForm.delimode,
                accountsflag: this.ticsQueryInfo.accountsflag,
                directcode: this.ticsQueryInfo.directcode,
                flowdetailcode: this.ticsQueryInfo.flowdetailcode,
                startsubmitdate: this.searchGLForm.paiTime.length>0?this.dateTime(this.searchGLForm.paiTime[0]):'',
                endsubmitdate: this.searchGLForm.paiTime.length>0?this.dateTime(this.searchGLForm.paiTime[1]):'',
                startdate: this.searchGLForm.outTime.length>0?this.dateTime(this.searchGLForm.outTime[0]):'',
                enddate: this.searchGLForm.outTime.length>0?this.dateTime(this.searchGLForm.outTime[1]):'',
                cardkind: this.cardkind,
                 bbindflowsend: this.searchGLForm.bbindflowsend,
            };
            return detailParams;
        },
        // 获取券卡统计详情列表
        getCardstatisticsDetail() {
            this.loading = true;
            let detailParams = this.returnQueryInfo();
            detailParams.pageparam = {
                pagesize: this.pageSize, //每页条数
                currentpage: this.currentPage, //当前页数
                isnewcomp: 1 //是否需要重新统计页数
            }
            api.GET_ACCOUNTSCARDDETAIL(detailParams).then(res => {
                this.toTableTop('gsTable');
                this.loading = false;
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data !='null') {
                        this.cardStatisticsList = res.data.data;
                    } else {
                        this.cardStatisticsList = [];
                    }
                    this.pagebBean = res.data.pagebean;
                }
            }).catch(res => {
                this.loading = false;
            })
        },
        // 接收分页信息
        updatePage(size,num) {
            this.pageSize = size;
            this.currentPage = num;
            this.getCardstatisticsDetail();
        },
        // 检索确定事件
        querySubmit() {
            this.currentPage = 1;
            this.getCardstatisticsDetail();
        },
        // 查看券卡专区信息
        seeGoodsInfo(code) {
            this.cardCode = code;
            this.goodsChoseDialogVisible = true;
        },
        // 关闭商品弹窗
        closeGoodsChoose() {
            this.cardCode = '';
            this.goodsChoseDialogVisible = false;
        },
        // 获取券卡状态的值
        cardStateObtain(val) {
            this.searchGLForm.cardState = val;
        },
    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    mounted () {
        if(this.$route.query.cardkind) {
            this.cardkind = this.$route.query.cardkind;
        }
        if(sessionStorage.getItem('detailQueryInfo')&&sessionStorage.getItem('detailQueryInfo')!=undefined) {
            this.ticsQueryInfo = JSON.parse(sessionStorage.getItem('detailQueryInfo'));
            this.searchGLForm = {
                cardState: [], // 券卡状态
                cardMedium: '', // 券卡介质
                flowcode: [], // 流向方编号
                delimode: '', // 送货方式
                outTime: this.ticsQueryInfo.outTime, // 出库时间
                paiTime: this.ticsQueryInfo.paiTime, // 提货时间
                bbindflowsend: this.$route.query.bbindflowsend
            }
            this.getCardstatisticsDetail();
        };
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();
        },200)

    },
    computed: {},
    destroyed(){ 
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
}
</script>
<style scoped>
@import '../../GoodsFolder/Css/style.css';
.mainPart {padding: 20px; height: calc(100% - 50px);}
.gsTable em{
    display: inline-block;
    vertical-align: middle;
    height: 20px;
    width: 20px;
    color:
    #fff;
    border-radius: 50%;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    margin-left: 10px;
}
.gsTable .orange{background-color: #FF7018;}
.gsTable .blue{background-color: var(--main-color);}
.gsTable .iconhand::before {
    font-size: 20px;
    padding-right: 5px;
    display: inline-block;
    vertical-align: top;
}
.gsTable >>> .el-table__header .el-form-item {margin-bottom:0!important;}
.goodsUse {position:relative;height:36px;padding-right:15px;border-right:solid 1px #dcdfe6;}
.goodsUse em {position:absolute; left:0; top:-20px; font-size: 12px; color:#999;}
.gsTable.el-table >>> thead.is-group > tr:first-child th .cell{overflow: visible!important;}
.gsTable.el-table >>> thead.is-group > tr:nth-child(2) th .cell {color:#333;}
.gsTable.el-table >>> .el-table__body .el-checkbox {padding:20px;}
.gsTable.el-table >>> .el-table__header .el-checkbox {padding:0 20px;}
.gsTable >>> .el-dropdown-link {cursor: pointer; color: var(--main-color);}
.inlineMember {padding:0 10px; border:solid 1px #dcdfe6; height:38px; line-height:38px;}
.childView.takeLeft .inlineMember,.childView.helpRight .inlineMember {margin-top:0px;}
@media only screen and (max-width: 1700px) {
  .inlineMember {margin-top:10px;} 
}
.inlineMember a:first-child {position:relative; width:30px; height:30px; margin:3px 0; border-radius:50%; overflow: hidden; border:solid 1px #ebeef5; }
.inlineMember img {position:absolute; left:0; top:0; right:0; bottom:0; margin:auto; width:30px; }
.inlineMember * {display:inline-block; vertical-align: top; font-size: 14px;}
.inlineMember span {margin-right:10px;}
.inlineMember i {color:#999;}
.inlineMember em {max-width:150px; width: auto;}
.inlineMember .iconmale {font-size: 18px;color:var(--main-color);}
.inlineMember .iconfemale {font-size: 18px;color:#f56c6c;}
.goodsImg{
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
  border: solid 1px #dcdfe6;
  border-radius:100%;
  margin-right:10px;
}
.goodsImg img {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  max-width: 100%;
  border-radius: 50%;
}
.goodsCont h3{font-size:14px!important;font-weight:bold;}
.goodsCont p{font-size:12px;}
.goodsCont{width: calc(100% - 65px);}
.actShow {padding-top:10px; color:#999;  font-size: 12px;}
.actShow span {display:inline-block; margin-right:35px;}
.actShow span b {font-weight: 600; padding-right:5px;}
/*归类统计弹窗*/
.seniorMdg >>> .el-dialog {width:500px;}
.seniorMdg >>> .el-form-item__content {width:65%; min-width: 200px; max-width: 340px;}
.seniorMdg >>> .el-form-item__content .el-select {width:100%;}
.none{display: none;}
.block{display: block;}
.serialBox,.serialBox p {text-align: center;}
.textFl.pdr50 {width:auto; padding-right:50px;}
.blackColor b {font-size: 14px; color:#666;}
.blackColor b:before {font-size: 14px; padding-right:5px;}
.blackColor .icongh:before{font-size: 16px;}
.center{text-align: center;}
</style>



// WEBPACK FOOTER //
// src/views/StatisticsFolder/DealerStatistics/CardStatisticsDetail.vue